module.exports = __webpack_public_path__ + "img/ser10.1e4796f5.png";